import { render, staticRenderFns } from "./ClientePrazoPagamento.vue?vue&type=template&id=9bafccfc&scoped=true"
import script from "./ClientePrazoPagamento.vue?vue&type=script&lang=js"
export * from "./ClientePrazoPagamento.vue?vue&type=script&lang=js"
import style0 from "./ClientePrazoPagamento.vue?vue&type=style&index=0&id=9bafccfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bafccfc",
  null
  
)

export default component.exports